import { render, staticRenderFns } from "./JoinPrivateCast.vue?vue&type=template&id=198ffd06&scoped=true&"
import script from "./JoinPrivateCast.vue?vue&type=script&lang=js&"
export * from "./JoinPrivateCast.vue?vue&type=script&lang=js&"
import style0 from "./JoinPrivateCast.vue?vue&type=style&index=0&id=198ffd06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198ffd06",
  null
  
)

export default component.exports